(function () {
  // Apps that change the cart themselves (Kite: Discount & Free Gift adding or
  // removing a free gift) update the theme through its Concept integration.
  // That integration only calls onCartUpdate() on the FIRST <cart-count> in the
  // DOM (document.querySelector('cart-count') -> the header icon), so the copy
  // in the cart drawer header and the one in the mobile dock keep their old
  // value. Mirror every update to all counters.
  if (!window.customElements) return;

  customElements.whenDefined('cart-count').then(() => {
    const CartCount = customElements.get('cart-count');
    const onCartUpdate = CartCount.prototype.onCartUpdate;

    if (typeof onCartUpdate !== 'function') return;

    CartCount.prototype.onCartUpdate = function (event) {
      onCartUpdate.call(this, event);

      document.querySelectorAll('cart-count').forEach((element) => {
        // Call the original so this stays a single fan-out, never a loop.
        if (element !== this) onCartUpdate.call(element, event);
      });
    };
  });
})();
